module.exports = __webpack_public_path__ + "static/use-case-5-content-7-b-3890f24bc7b6f73cfa883276c1fbedfc.png";